import request from '@/axios/request.js'

// 获取首页内容
export function getIndexPageList() {
    return request({
        url: '/api/index',
        method: 'get'
    })
}

// 热门搜索关键字获取
export function getKeyWord() {
    return request({
        url: '/api/search/keyword',
        method: 'get'
    })
}

// 获取商品列表
export function getProducts(params) {
    // {
    //     'isIntegral': 0, // 是否积分兑换商品 0否  1是
    //     'keyword': '', // 关键
    //     'news': '', // 是否新品  0否  1是
    //     'priceOrder': '', // 价格排序  desc正序  asc倒序
    //     'salesOrder': '', // 销量排序
    //     'sid': '', // 分类ID
    //     'type': '', // 类别 不传
    //     'limit': 10,
    //     'page': 1
    // }
    return request({
        url: '/api/pc/products',
        method: 'get',
        params
    })
}

// 获取分类id
export function getCategory(params) {
    return request({
        url: '/api/category',
        method: 'get',
        params
    })
}

export function getCanvasData(params) {
    return request({
        url: '/api/getCanvas',
        method: 'get',
        params
    })
}

export function getIndexall() {
    return request({
        url: '/api/pc/index',
        method: 'get'
        // params
    })
}

export function getNaviInfo() {
    return request({
        url: '/api/pc/indexNav',
        method: 'get'
    })
}



// WEBPACK FOOTER //
// ./src/api/indexpage.js